import { render, staticRenderFns } from "./simple-select.vue?vue&type=template&id=82de7f22&scoped=true"
import script from "./simple-select.vue?vue&type=script&lang=js"
export * from "./simple-select.vue?vue&type=script&lang=js"
import style0 from "./simple-select.vue?vue&type=style&index=0&id=82de7f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82de7f22",
  null
  
)

export default component.exports